import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

// Fallback list — used only if API returns nothing (defensive).
const FALLBACK = [
    { name: "Badrutt's Palace, St. Moritz", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/offo8nei_1.png" },
    { name: "Association Le Foyer", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/lj75anjx_2.png" },
    { name: "Fyae — Accueil de l'Enfance", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/3r2ibxqw_3.png" },
    { name: "Zagara Restaurant & Lounge Bar", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/p7vppdgg_4.png" },
    { name: "Restaurant de la Place", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/7ofr6qso_5.png" },
    { name: "Café Primeur", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/ifw0kczd_6.png" },
    { name: "Schneider — Confiserie & Tea-Room", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/8f2wr5w4_7.png" },
    { name: "Café du Commerce", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/g5p6amxu_8.png" },
    { name: "eHnv — Établissements Hospitaliers du Nord Vaudois", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/lcs2y7kv_9.png" },
    { name: "Semo Nord", image: "https://customer-assets.emergentagent.com/job_portail-pro/artifacts/8nym20b9_10.png" },
];

export default function PartnersStrip() {
    const { data: logos = FALLBACK } = useQuery({
        queryKey: ["client-logos"],
        queryFn: async () => {
            const list = (await api.get("/client-logos")).data;
            return list && list.length > 0 ? list : FALLBACK;
        },
        staleTime: 60_000,
    });

    if (!logos || logos.length === 0) return null;

    return (
        <section className="relative py-8 md:py-10 partners-section" data-testid="partners-section">
            <div className="max-w-6xl mx-auto px-5 md:px-10 mb-6 text-center">
                <h2
                    className="font-serif text-black text-3xl sm:text-4xl"
                    style={{ fontFamily: "Marcellus, serif" }}
                >
                    Ils nous font confiance
                </h2>
                <div
                    className="mx-auto mt-3"
                    style={{ height: "1px", width: "48px", background: "#000" }}
                />
            </div>
            <div className="relative partners-viewport">
                <div className="partners-fade partners-fade--left partners-fade--gold" />
                <div className="partners-fade partners-fade--right partners-fade--gold" />
                <div className="partners-track">
                    {[...logos, ...logos].map((p, i) => {
                        const inner = (
                            <div
                                className="partner-card partner-card--dark"
                                data-testid={i < logos.length ? `partner-${p.id || i}` : undefined}
                                title={p.name}
                            >
                                <img src={p.image} alt={p.name} loading="lazy" draggable={false} />
                            </div>
                        );
                        return p.url ? (
                            <a
                                key={`${p.name}-${i}`}
                                href={p.url}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                {inner}
                            </a>
                        ) : (
                            <React.Fragment key={`${p.name}-${i}`}>{inner}</React.Fragment>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
